import React, { createRef } from 'react';
import { Box, Paper } from '@mui/material';
import DroughtWarningFilterBar from './components/drought-warning/DroughtWarningFilterBar';
import { DroughtWarningProvider } from './components/drought-warning/DroughtWarningContext';
import DroughtWarningSidebar from './components/drought-warning/DroughtWarningSidebar';
import MapWrapper from '../components/mapwrapper/MapWrapper';
import DataOverview from '../components/overview/DataOverview';

const DroughtWarningPageContent = () => {
    const overview = createRef();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: { xs: 1.5, md: 0 },
                height: { xs: 'auto', md: '100%' },
                minHeight: 0,
                width: '100%',
            }}
        >
            <Box
                sx={{
                    order: { xs: 2, md: 1 },
                    display: 'flex',
                    height: { xs: 'auto', md: '100%' },
                    minHeight: 0,
                    width: { xs: '100%', md: 420 },
                    flex: { xs: '0 0 auto', md: '0 0 420px' },
                    flexShrink: 0,
                    minWidth: { md: 420 },
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        height: { xs: 'auto', md: '100%' },
                        overflowY: { xs: 'visible', md: 'auto' },
                        pr: { xs: 0, md: 1 },
                        backgroundColor: '#fafbfd',
                        width: '100%',
                    }}
                >
                    <DroughtWarningSidebar />
                </Paper>
            </Box>
            <Box
                sx={{
                    order: { xs: 1, md: 2 },
                    display: 'flex',
                    flex: { xs: '0 0 auto', md: '1 1 0' },
                    flexDirection: 'column',
                    height: { xs: 'auto', md: '100%' },
                    minHeight: 0,
                    minWidth: 0,
                    width: { xs: '100%', md: 'auto' },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: { xs: 1.5, md: 2 },
                        height: { xs: 'auto', md: '100%' },
                        minHeight: 0,
                        width: '100%',
                    }}
                >
                    <DroughtWarningFilterBar />
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            flex: { md: 1 },
                            height: { xs: '58vh', sm: '62vh', md: 'auto' },
                            minHeight: { xs: 360, sm: 420, md: 0 },
                            maxHeight: { xs: 620, md: 'none' },
                            minWidth: 0,
                            width: '100%',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                height: { xs: '100%', md: 'calc(100% - 52.5px)' },
                                width: '100%',
                                minHeight: 0,
                            }}
                        >
                            <MapWrapper overviewRef={overview} />
                        </Box>
                        <DataOverview ref={overview} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

const DroughtWarningPage = () => (
    <DroughtWarningProvider>
        <DroughtWarningPageContent />
    </DroughtWarningProvider>
);

export default DroughtWarningPage;
